import React, { useEffect, useState } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function Hero() {
  const revealRef = useScrollReveal();
  const [particles, setParticles] = useState<{
    id: number;
    top: string;
    left: string;
    size: string;
    duration: string;
    delay: string;
  }[]>([]);
  useEffect(() => {
    const newParticles = Array.from({
      length: 80
    }).map((_, i) => ({
      id: i,
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      size: `${Math.random() * 1 + 1}px`,
      duration: `${Math.random() * 6 + 6}s`,
      delay: `${Math.random() * 5}s`
    }));
    setParticles(newParticles);
  }, []);
  return <section className="relative w-full min-h-screen flex items-center bg-brand-dark bg-grain overflow-hidden py-[60px] md:py-[100px]" data-id="element-138">
      {/* Particles */}
      <div className="absolute inset-0 pointer-events-none z-0" data-id="element-139">
        {particles.map(p => <div key={p.id} className="particle" style={{
        top: p.top,
        left: p.left,
        width: p.size,
        height: p.size,
        animationDuration: p.duration,
        animationDelay: p.delay
      }} data-id="element-140" />)}
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-5 w-full text-center flex flex-col items-center" data-id="element-141">
        <div ref={revealRef} className="reveal flex flex-col items-center" data-id="element-142">
          <div className="inline-flex items-center border border-brand-gold/30 text-brand-gold text-[11px] tracking-[0.1em] uppercase rounded-[40px] py-[6px] px-[18px] mb-[32px]" data-id="element-143">
            ✦ EDICIÓN MAESTRO: TRANSMUTACIÓN DEL INCONSCIENTE
          </div>

          <h1 className="font-display italic text-[clamp(48px,8vw,96px)] font-light leading-[1.05] text-brand-cream mb-6" data-id="element-144">
            No atraes lo que quieres.
            <br data-id="element-145" />
            Atraes lo que <span className="text-brand-gold" data-id="element-146">eres</span>.
          </h1>

          <p className="font-body font-light text-[17px] leading-[1.75] text-brand-cream/65 max-w-[600px] mb-12" data-id="element-147">
            Si llevas años intentando sanar y sigues en el mismo lugar — el
            problema no es tu esfuerzo. Es que nunca trabajaste a nivel
            subatómico.
          </p>

          <a href="#producto" className="inline-block bg-brand-gold text-brand-dark font-body text-[16px] font-medium py-[18px] px-[42px] rounded-[50px] transition-all duration-300 hover:bg-brand-goldBright hover:-translate-y-[2px] hover:shadow-[0_8px_28px_rgba(201,169,110,0.3)] w-full md:w-auto" data-id="element-148">
            Sí, quiero RENACER &rarr;
          </a>

          <p className="font-body text-[13px] text-brand-cream/40 mt-4" data-id="element-149">
            Descarga inmediata &middot; Garantía 7 días &middot; +500 lectores
          </p>

          <div className="flex flex-row flex-wrap justify-center gap-6 mt-12" data-id="element-150">
            {['⚡ Acceso instantáneo', '🔒 Pago seguro', '🛡️ Garantía total'].map((badge, i) => <div key={i} className="flex items-center gap-2 font-body text-[13px] text-brand-cream/50" data-id="element-151">
                {badge}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}